<div class="container mt-4">
  <h1 class="mb-0"
    id="program-program-information-heading">Program Information</h1>
  <div class="row mt-3">
    <div class="col-md-4">
      <app-recent-programs *ngIf="showRecentPrograms"></app-recent-programs>
    </div>
    <div class="col-md-4">
      <div class="row">
        <app-program-shortcuts *ngIf="showShortcuts"></app-program-shortcuts>
        <app-service-requests *ngIf="showSRPanel"></app-service-requests>
      </div>
    </div>
    <div class="col-md-4"><app-policy-document-search *ngIf="showProgramSearch"></app-policy-document-search></div>
  </div>
</div>
<app-feedback></app-feedback>
<app-chat></app-chat>